import React from 'react'

import TabTitle from '@/components/misc/CompanyProfile/components/TabTitle'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Card, CardContent } from '@/components/ui/card'
import { FcaService } from '@/types/misc'

interface Props {
  services: FcaService[]
}

const FcaServices: React.FC<Props> = ({ services }) => (
  <>
    <TabTitle>Services offered</TabTitle>

    <Card className="pt-1 pb-0">
      <CardContent>
        <Accordion type="single" collapsible defaultValue="0">
          {services.map((service, index) => (
            <AccordionItem key={index} value={index.toString()}>
              <AccordionTrigger asChild>{service.category}</AccordionTrigger>

              <AccordionContent>
                {service.permissions.map((permission, index) => (
                  <p key={index} className="mb-4">
                    {permission}
                  </p>
                ))}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </CardContent>
    </Card>
  </>
)

export default FcaServices
